// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTADocumentContent } from './dta-document-content';
import {
    DTADocumentContentFromJSON,
    DTADocumentContentFromJSONTyped,
    DTADocumentContentToJSON,
    DTADocumentContentToJSONTyped,
} from './dta-document-content';

/**
 * 
 * @export
 * @interface ParsedFormResult
 */
export interface ParsedFormResult {
    /**
     * 
     * @type {number}
     * @memberof ParsedFormResult
     */
    codelist_count: number;
    /**
     * 
     * @type {number}
     * @memberof ParsedFormResult
     */
    cross_form_rule_count: number;
    /**
     * 
     * @type {DTADocumentContent}
     * @memberof ParsedFormResult
     */
    document_content?: DTADocumentContent;
    /**
     * SDTM domain code the dataset belongs to (e.g. DM for DM/SUPPDM/XREF_DM). Set by the SDTM parser; absent for EDC forms.
     * @type {string}
     * @memberof ParsedFormResult
     */
    domain?: string;
    /**
     * 
     * @type {number}
     * @memberof ParsedFormResult
     */
    field_count: number;
    /**
     * 
     * @type {boolean}
     * @memberof ParsedFormResult
     */
    is_repeating: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParsedFormResult
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof ParsedFormResult
     */
    max_repeats?: number;
    /**
     * 
     * @type {string}
     * @memberof ParsedFormResult
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ParsedFormResult
     */
    rule_count: number;
}

/**
 * Check if a given object implements the ParsedFormResult interface.
 */
export function instanceOfParsedFormResult(value: object): value is ParsedFormResult {
    if (!('codelist_count' in value) || value['codelist_count'] === undefined) return false;
    if (!('cross_form_rule_count' in value) || value['cross_form_rule_count'] === undefined) return false;
    if (!('field_count' in value) || value['field_count'] === undefined) return false;
    if (!('is_repeating' in value) || value['is_repeating'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rule_count' in value) || value['rule_count'] === undefined) return false;
    return true;
}

export function ParsedFormResultFromJSON(json: any): ParsedFormResult {
    return ParsedFormResultFromJSONTyped(json, false);
}

export function ParsedFormResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedFormResult {
    if (json == null) {
        return json;
    }
    return {
        
        'codelist_count': json['codelist_count'],
        'cross_form_rule_count': json['cross_form_rule_count'],
        'document_content': json['document_content'] == null ? undefined : DTADocumentContentFromJSON(json['document_content']),
        'domain': json['domain'] == null ? undefined : json['domain'],
        'field_count': json['field_count'],
        'is_repeating': json['is_repeating'],
        'label': json['label'],
        'max_repeats': json['max_repeats'] == null ? undefined : json['max_repeats'],
        'name': json['name'],
        'rule_count': json['rule_count'],
    };
}

export function ParsedFormResultToJSON(json: any): ParsedFormResult {
    return ParsedFormResultToJSONTyped(json, false);
}

export function ParsedFormResultToJSONTyped(value?: ParsedFormResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'codelist_count': value['codelist_count'],
        'cross_form_rule_count': value['cross_form_rule_count'],
        'document_content': DTADocumentContentToJSON(value['document_content']),
        'domain': value['domain'],
        'field_count': value['field_count'],
        'is_repeating': value['is_repeating'],
        'label': value['label'],
        'max_repeats': value['max_repeats'],
        'name': value['name'],
        'rule_count': value['rule_count'],
    };
}
